import { render, staticRenderFns } from "./ViewpointsIndex.vue?vue&type=template&id=3366ab02&"
import script from "./ViewpointsIndex.vue?vue&type=script&lang=js&"
export * from "./ViewpointsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports